module.exports = __webpack_public_path__ + "img/wallet-black.352878fa.svg";